export const FormatsData: {[k: string]: ModdedSpeciesFormatsData} = {
	beedrillmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	pidgeotmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	pikachucosplay: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	pikachurockstar: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	pikachubelle: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	pikachupopstar: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	pikachuphd: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	pikachulibre: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	slowbromega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	steelixmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	sceptilemega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	swampertmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	sableyemega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	sharpedomega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	cameruptmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	altariamega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	glaliemega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	salamencemega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	metagrossmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	latiasmega: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	latiosmega: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	kyogreprimal: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	groudonprimal: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	rayquazamega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	lopunnymega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	gallademega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	audinomega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	dianciemega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	hoopa: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
	hoopaunbound: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	volcanion: {
		isNonstandard: "Unobtainable",
		tier: "Unreleased",
	},
};
